import React from 'react';

const SVG = ({
  style = {},
  className = '',
  viewBox = '0 0 100 100',
  ...rest
}) => (
  <svg
    style={style}
    className={className}
    viewBox={viewBox}
    id="icon-svg-close"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      d="M44.03 26L23.96 46l-20-20L0 29.97l20 20L0 70.02 3.97 74l20-20.07L44.02 74 48 70.03 27.93 49.96l20.07-20z"
    ></path>
  </svg>
);

export default SVG;